import { preOrderingMobx } from '@mobxStore'
import { restaurantConfig, restaurantCenter, RESTAURANT_EVENT, cartMobx, storeMobx } from 'restaurant'
import { localStore } from '@dt/fe-utils'

const setCart = () => {
  const storeId = restaurantConfig.storeId
  if (storeId) {
    const cartInfo = localStore.get('cart.cache') || {}
    cartInfo[storeId] = cartMobx.getCopy(false)
    localStore.set('cart.cache', cartInfo)
  }
}

export const getCart = (storeId: number, ordersId?: string) => {
  const curCart = localStore.get('cart.cache') && localStore.get('cart.cache')[storeId.toString()] || false
  if (curCart && curCart.createTime + 6 * 60 * 60 * 1000 > Date.now()) {
    // 判断是否为当前这笔订单的餐品
    if (!curCart.ordersId || curCart.ordersId === ordersId) {
      return curCart
    }
    return null
  } else {
    if (curCart.createTime + 6 * 60 * 60 * 1000 < Date.now()) {
      localStore.remove('cart.cache')
    }
    return null
  }
}

restaurantCenter.on([RESTAURANT_EVENT.CART_ITEMS_CHANGED, RESTAURANT_EVENT.SAVE_ORDER], (cart: any) => {
  // 拼单不缓存购物车
  if (Config.codeType === 'brand' && Config.buyTogetherId) {
    return
  }
  // 多人点餐不缓存购物车
  if (Config.codeType === 'table' && Config.TABLECODE && storeMobx.info?.openMultiPersonOrdering) {
    return
  }
  // 排队预点餐不缓存购物车
  if (Config.codeType === 'store' && Config.queueId) {
    return
  }
  if (location.pathname.indexOf('/result') === -1) {
    if (preOrderingMobx.checkPreOrder) {
      preOrderingMobx.setCart()
    } else {
      setCart()
    }
  }
})

restaurantCenter.on([RESTAURANT_EVENT.CART_ITEMS_BATCH_CHANGED], ({ cache }: any) => {
  // 拼单不缓存购物车
  if (Config.codeType === 'brand' && Config.buyTogetherId) {
    return
  }
  // 多人点餐不缓存购物车
  if (Config.codeType === 'table' && Config.TABLECODE && storeMobx.info?.openMultiPersonOrdering) {
    return
  }
  // 排队预点餐不缓存购物车
  if (Config.codeType === 'store' && Config.queueId) {
    return
  }
  if (location.pathname.indexOf('/result') === -1 && cache) {
    setCart()
  }
})
